import { useEffect } from 'react';
import { HumanPlaceholder } from 'atomicComponents/HumanPlaceholder/HumanPlaceholder';
import { DataLimitProps } from './types';
import { getWarningSubtitle, getWarningTitle } from './utils';
import { trackShowingDataLimitWarning } from './trackings';
import { ViewIds } from '@ardoq/api-types';
import { DoqWarning } from './DoqWarning';
import { connect } from '@ardoq/rxbeach';
import { combineLatest, map } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { activeView$ } from 'streams/views/mainContent/activeView$';
import { t, type I18nLocale } from '@ardoq/i18n';

type DataLimitViewProps = DataLimitProps & {
  i18nLocale: I18nLocale;
  activeViewId: ViewIds;
};

const DataLimitView = (props: DataLimitViewProps) => {
  useEffect(() => {
    trackShowingDataLimitWarning(props, props.activeViewId);
  }, [props]);

  if (
    props.isAboveLimit &&
    (props.viewId === ViewIds.BLOCK_DIAGRAM ||
      props.viewId === ViewIds.MODERNIZED_BLOCK_DIAGRAM ||
      props.viewId === ViewIds.SWIMLANE)
  ) {
    return (
      <DoqWarning
        viewId={props.viewId}
        canBypass={props.canBypass}
        onContinueClick={props.onBypassClick}
        isCanvasPrototype={props.isCanvasPrototype}
        isViewpointMode={props.isViewpointMode}
      />
    );
  }

  return (
    <HumanPlaceholder
      title={getWarningTitle(props, props.i18nLocale)}
      subtitle={getWarningSubtitle(props, props.i18nLocale)}
      actions={
        props.canBypass && props.onBypassClick
          ? [
              {
                label: t(
                  props.i18nLocale,
                  'dataLimit:button.proceedAnyway',
                  'PROCEED ANYWAY'
                ),
                isPrimary: true,
                onClick: props.onBypassClick,
              },
            ]
          : []
      }
    />
  );
};

const DataLimit = connect(
  DataLimitView,
  combineLatest({ i18nLocale: i18nLocale$, activeView: activeView$ }).pipe(
    map(({ i18nLocale, activeView }) => ({
      i18nLocale,
      activeViewId: activeView.mainViewId,
    }))
  )
);

export { DataLimit };
